// Central site content + config for FYLegal.ID
export const CONTACT = {
  phoneDisplay: "0852-1878-3322",
  phoneRaw: "6285218783322",
  email: "hello@fylegal.id",
  address: "Pulo Gebang, Jakarta Timur 13950",
  instagram: "https://www.instagram.com/fylegal.id",
  instagramHandle: "@fylegal.id",
  tiktok: "https://www.tiktok.com/@fylegalid",
  tiktokHandle: "@fylegalid",
  company: "PT AYRIZ LAW SOLUTIONS",
  brand: "FYLegal.ID",
  tagline: "For Your Legal Needs",
};

export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_f352520c-8850-4fb6-9b68-2e500e5fdd93/artifacts/fs7a55f5_1cadd894-2a40-4649-9367-c37ea22d241c.JPG";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1600531529272-023c4b821f14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  handshake:
    "https://images.unsplash.com/photo-1758518729240-7162d07427b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  meeting:
    "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const waLink = (message) =>
  `https://wa.me/${CONTACT.phoneRaw}?text=${encodeURIComponent(
    message || "Halo FYLegal.ID, saya ingin berkonsultasi mengenai kebutuhan hukum saya."
  )}`;

export const NAV_LINKS = [
  { label: "Beranda", href: "#beranda" },
  { label: "Tentang", href: "#tentang" },
  { label: "Layanan", href: "#layanan" },
  { label: "Harga", href: "#harga" },
  { label: "Cara Kerja", href: "#cara-kerja" },
  { label: "Klien", href: "#klien" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontak", href: "#kontak" },
];

export const STATS = [
  { value: "500+", label: "Klien Terlayani" },
  { value: "100+", label: "Perusahaan & UMKM" },
  { value: "15+", label: "Bidang Layanan Hukum" },
  { value: "24/7", label: "Fast Response" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Siapa Kami",
    body:
      "FYLegal.ID merupakan brand layanan hukum di bawah naungan PT AYRIZ LAW SOLUTIONS, didirikan pada Juli 2024. Kami hadir sebagai mitra hukum terpercaya bagi individu, UMKM, startup, hingga perusahaan.",
  },
  {
    no: "02",
    title: "Yang Kami Percaya",
    body:
      "Hukum bukan sekadar menyelesaikan masalah, tetapi memberikan kepastian, perlindungan, dan rasa aman bagi setiap klien. Setiap orang berhak atas layanan hukum yang profesional, transparan, dan mudah diakses.",
  },
  {
    no: "03",
    title: "Cara Kami Bekerja",
    body:
      "Kami memadukan pendekatan profesional dengan komunikasi yang mudah dipahami masyarakat umum — memastikan Anda selalu memahami setiap langkah, biaya, dan estimasi penyelesaian sejak awal.",
  },
];

export const SERVICE_FILTERS = [
  { id: "all", label: "Semua" },
  { id: "legalitas", label: "Legalitas Bisnis" },
  { id: "perizinan", label: "Perizinan" },
  { id: "hki", label: "HKI" },
  { id: "corporate", label: "Corporate Legal" },
  { id: "perdata", label: "Perdata & Keluarga" },
  { id: "sengketa", label: "Sengketa" },
];

export const SERVICES = [
  {
    id: "legalitas",
    icon: "FileText",
    title: "Legalitas Bisnis",
    tags: ["PT", "CV", "Yayasan", "Firma", "Perubahan Akta", "Pembubaran"],
  },
  {
    id: "perizinan",
    icon: "ClipboardCheck",
    title: "Perizinan Berusaha",
    tags: ["OSS", "NIB", "Sertifikat Standar", "Perizinan Risiko", "Perizinan Sektoral"],
  },
  {
    id: "hki",
    icon: "Lightbulb",
    title: "Hak Kekayaan Intelektual",
    tags: ["Merek", "Hak Cipta", "Desain Industri", "Rahasia Dagang", "Sengketa HKI"],
  },
  {
    id: "corporate",
    icon: "Building2",
    title: "Corporate Legal",
    tags: ["Review Kontrak", "Penyusunan Kontrak", "Due Diligence", "Legal Opinion", "Compliance"],
  },
  {
    id: "perdata",
    icon: "Users",
    title: "Hukum Perdata & Keluarga",
    tags: ["Waris", "Hibah", "Wasiat", "Perjanjian Nikah", "Hak Asuh"],
  },
  {
    id: "sengketa",
    icon: "Scale",
    title: "Penyelesaian Sengketa",
    tags: ["Somasi", "Mediasi", "Negosiasi", "Litigasi"],
  },
];

export const ADVANTAGES = [
  {
    title: "Free Konsultasi Hukum",
    body: "Konsultasikan kebutuhan hukum Anda tanpa biaya sebelum memutuskan langkah selanjutnya.",
    icon: "Gift",
  },
  {
    title: "Transaksi Cepat, Aman & Terjamin",
    body: "Proses yang efisien dengan penanganan yang aman dan hasil yang terjamin.",
    icon: "ShieldCheck",
  },
  {
    title: "Biaya Hemat, Transparan & Terjangkau",
    body: "Harga jelas sejak awal, hemat, dan terjangkau tanpa biaya tersembunyi.",
    icon: "Wallet",
  },
  {
    title: "Kerahasiaan & Keamanan Data Terjamin",
    body: "Setiap informasi dan data klien dijaga dengan integritas dan kerahasiaan penuh.",
    icon: "Lock",
  },
  {
    title: "Dikerjakan oleh Tim Profesional",
    body: "Ditangani langsung oleh tim dan praktisi hukum yang berpengalaman di bidangnya.",
    icon: "Users",
  },
  {
    title: "Praktis & Tanpa Ribet",
    body: "Semua urusan hukum Anda kami permudah — praktis, cepat, dan tanpa ribet.",
    icon: "Sparkles",
  },
];

export const STD_INCLUDED = [
  "Cek & Pesan Nama",
  "Akta Pendirian",
  "SK Kemenkum",
  "Akun Coretax",
  "E-NPWP & SKT",
  "Dan berbagai dokumen pendukung lainnya",
];

export const PRICING = [
  {
    id: "badan-usaha",
    tag: "01",
    heading: "Pendirian Badan Usaha",
    type: "priced",
    items: [
      { name: "Pendirian PT", price: "Rp 3.000.000", includes: STD_INCLUDED },
      { name: "Pendirian CV", price: "Rp 2.000.000", includes: STD_INCLUDED },
      {
        name: "Pendirian PT Perorangan",
        price: "Rp 500.000",
        includes: [
          "Cek & Pesan Nama",
          "SK Kemenkum",
          "Akun Coretax",
          "E-NPWP & SKT",
          "Dan berbagai dokumen pendukung lainnya",
        ],
      },
      { name: "Pendirian Perkumpulan", price: "Rp 3.000.000", includes: STD_INCLUDED },
      { name: "Pendirian Yayasan", price: "Rp 3.000.000", includes: STD_INCLUDED },
      { name: "Pendirian Koperasi", price: "Rp 3.000.000", includes: STD_INCLUDED },
    ],
  },
  {
    id: "add-ons",
    tag: "02",
    heading: "Add-ons — Izin Usaha & Pendukung Bisnis",
    type: "priced",
    items: [
      { name: "Pengurusan NPWP", price: "Rp 250.000" },
      { name: "Pendaftaran HAKI (Hak Cipta, Merek & Paten)", price: "Rp 2.000.000" },
      { name: "Pembuatan atau Pengurusan NIB & OSS", price: "Rp 500.000" },
      {
        name: "Rapat Umum Pemegang Saham Tahunan (RUPST)",
        price: "Rp 3.000.000",
        includes: [
          "Salinan PKPS",
          "Surat Pemberitahuan Laporan Tahunan",
          "Dan berbagai dokumen pendukung lainnya",
        ],
      },
    ],
  },
  {
    id: "kenotariatan",
    tag: "03",
    heading: "Layanan Kenotariatan",
    type: "list",
    items: [
      "Perjanjian Pengikat Jual Beli (PPJB)",
      "Perjanjian Pra Nikah & Pasca Nikah",
      "Akta Kuasa",
      "Akta Wasiat",
      "Akta Perjanjian Sewa Menyewa",
      "Akta Notaris Lainnya",
    ],
  },
  {
    id: "lainnya",
    tag: "04",
    heading: "Layanan Lainnya",
    type: "list",
    items: ["Waarmerking", "Legalisasi", "Pengecekan Sertifikat"],
  },
];

export const PROCESS = [
  { no: "01", title: "Konsultasi", body: "Hubungi kami lewat WhatsApp, telepon, email, atau formulir." },
  { no: "02", title: "Analisis", body: "Tim memahami kebutuhan hukum Anda secara menyeluruh." },
  { no: "03", title: "Penawaran", body: "Ruang lingkup, estimasi waktu, dan biaya disampaikan transparan." },
  { no: "04", title: "Proses", body: "Pekerjaan dilakukan oleh tenaga profesional berpengalaman." },
  { no: "05", title: "Penyelesaian", body: "Dokumen selesai; pendampingan lanjutan tetap tersedia." },
];

export const CLIENTS = [
  {
    title: "Individu & Keluarga",
    body: "Permasalahan perdata, keluarga, waris, dan perlindungan hak pribadi.",
    icon: "Users",
  },
  {
    title: "UMKM & Startup",
    body: "Legalitas usaha, perizinan, kontrak, dan perlindungan merek dagang.",
    icon: "Rocket",
  },
  {
    title: "Perusahaan & Investor",
    body: "Corporate legal, due diligence, compliance, dan legal retainer.",
    icon: "Building2",
  },
  {
    title: "Yayasan, Komunitas & Organisasi",
    body: "Pendirian badan usaha nirlaba dan pendampingan hukum organisasi.",
    icon: "HeartHandshake",
  },
  {
    title: "Kreator & Pemilik Merek",
    body: "Pendaftaran HKI, perlindungan karya, dan penanganan pelanggaran merek.",
    icon: "Palette",
  },
];

export const TRUST_REASONS = [
  {
    title: "Proses Transparan",
    body: "Biaya dan tahapan dijelaskan di awal, tanpa biaya tersembunyi.",
    icon: "ScrollText",
  },
  {
    title: "Kerahasiaan Terjamin",
    body: "Setiap informasi klien dijaga dengan integritas penuh.",
    icon: "Lock",
  },
  {
    title: "Pendampingan Hingga Selesai",
    body: "Kami tidak berhenti sampai persoalan Anda terselesaikan.",
    icon: "Flag",
  },
  {
    title: "Solusi Praktis & Aplikatif",
    body: "Rekomendasi hukum yang mudah diterapkan dalam bisnis dan kehidupan.",
    icon: "CheckCircle2",
  },
];

export const SERVICE_OPTIONS = [
  "Legalitas Bisnis & Perizinan Berusaha",
  "Hak Kekayaan Intelektual & Corporate Legal",
  "Hukum Perdata, Keluarga & Penyelesaian Sengketa",
  "Legal Retainer",
  "Konsultasi Lainnya",
];


export const SERVE = [
  { label: "Individu", icon: "User" },
  { label: "UMKM", icon: "Store" },
  { label: "Startup", icon: "Rocket" },
  { label: "Perusahaan", icon: "Building2" },
  { label: "Investor", icon: "TrendingUp" },
  { label: "Yayasan", icon: "HeartHandshake" },
  { label: "Kreator", icon: "Palette" },
  { label: "Organisasi", icon: "Users" },
];

export const RETAINER_PACKAGES = [
  {
    name: "Basic",
    subtitle: "Untuk individu & UMKM yang baru memulai",
    features: ["Konsultasi Hukum Dasar", "Review Dokumen Sederhana", "Respons via WhatsApp"],
    popular: false,
  },
  {
    name: "Business",
    subtitle: "Untuk startup yang sedang bertumbuh",
    features: [
      "Semua di Paket Basic",
      "Penyusunan & Review Kontrak",
      "Pendampingan Perizinan",
      "Prioritas Respons",
    ],
    popular: true,
  },
  {
    name: "Corporate",
    subtitle: "Untuk perusahaan dengan kebutuhan legal rutin",
    features: [
      "Semua di Paket Business",
      "Legal Compliance Berkala",
      "Legal Opinion & Due Diligence",
      "Pendampingan Negosiasi",
    ],
    popular: false,
  },
  {
    name: "Enterprise",
    subtitle: "Untuk korporasi & investor berskala besar",
    features: [
      "Semua di Paket Corporate",
      "Dedicated Legal Partner",
      "Pendampingan Sengketa Awal",
      "Laporan Berkala",
    ],
    popular: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Prosesnya dijelaskan dengan jelas sejak awal, jadi saya tahu persis apa yang saya bayar dan apa yang saya dapatkan.",
    name: "Pemilik UMKM, Jakarta",
    rating: 5,
  },
];

export const ARTICLES = [
  {
    category: "Legalitas Bisnis",
    title: "Panduan Memilih Antara PT dan CV",
    desc: "Perbandingan singkat kedua bentuk badan usaha yang paling umum di Indonesia.",
  },
  {
    category: "Perizinan",
    title: "Mengenal NIB dan Perizinan Berbasis Risiko",
    desc: "Apa saja yang perlu disiapkan sebelum mengajukan NIB melalui OSS.",
  },
  {
    category: "HKI",
    title: "Kenapa Merek Bisnis Anda Perlu Didaftarkan",
    desc: "Risiko yang bisa dihindari dengan pendaftaran merek sejak awal.",
  },
];

export const FAQS = [
  {
    q: "Apa perbedaan utama antara PT dan CV?",
    a: "PT memiliki status badan hukum penuh dan cocok untuk bisnis yang ingin berkembang atau menerima investasi, sedangkan CV lebih sederhana dan cocok untuk usaha kecil-menengah.",
  },
  {
    q: "Dokumen apa saja yang umumnya dibutuhkan untuk pendirian usaha?",
    a: "Umumnya dibutuhkan KTP pendiri, NPWP, alamat domisili usaha, dan data modal dasar. Tim kami akan memandu Anda sesuai jenis badan usaha yang dipilih.",
  },
  {
    q: "Apakah Fylegal.id menangani sengketa hingga ke pengadilan?",
    a: "Ya. Layanan kami tidak hanya berfokus pada penyelesaian non-litigasi (seperti mediasi, negosiasi, dan somasi), tetapi juga menangani sengketa secara litigasi hingga ke pengadilan. Pendampingan litigasi dilakukan oleh advokat sesuai ketentuan peraturan perundang-undangan yang berlaku.",
  },
  {
    q: "Bagaimana cara memulai konsultasi dengan Fylegal.id?",
    a: "Klik tombol Konsultasi di halaman ini atau hubungi kami langsung via WhatsApp. Tim kami akan merespons dan menjadwalkan sesi konsultasi gratis.",
  },
  {
    q: "Apakah paket Legal Retainer bisa disesuaikan?",
    a: "Ya, setiap paket dapat disesuaikan dengan kebutuhan dan skala bisnis Anda. Hubungi kami untuk mendiskusikan kebutuhan spesifik Anda.",
  },
];
